<template lang="pug">
AppPopover(
  ref="AppPopover"
  placement="right"
  show-header
  @show="loadNotesData"
)
  template(#header)
    span Notes
  template(#body)
    span
      .notes(
        :id="`notes_${timeSlot}`"
        v-loading="loading"
      )
        ActivitiesNote(
          v-for="note in notes"
          :key="note.id"
          :note-id="note.id"
          :note-project-name="note.project_task_name"
          :note-description="note.description"
          :note-recorded-at="note.recorded_at"
          :own-activity="ownActivity"
          @edit-dialog-opened="close"
        )
      a.btn.btn-sm.btn-block.btn-default(
        v-if="ownActivity"
        title="Add note"
        @click="showAddNoteDialog"
      )
        | Add note
  template(#trigger)
    slot(name="trigger")
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import ActivitiesNote from './ActivitiesNote.vue';

export default {
  name: 'ActivitiesNotePopover',
  components: {
    ActivitiesNote,
  },
  props: {
    ownActivity: {
      type: Boolean,
      required: true,
    },
    timeSlot: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      loading: true,
      notes: [],
      filterProjectId: null,
      notesId: null,
    };
  },
  computed: {
    ...mapGetters(['queryUserId']),
  },
  methods: {
    ...mapActions(['loadNotes']),
    close() {
      this.$refs.AppPopover.close();
    },
    showAddNoteDialog() {
      const projectId = this.filterProjectId;
      const urlParams =
        `?note[project_id]=${projectId}` +
        `&note[time_slot]=${this.timeSlot}` +
        `&notes_id=${this.notesId}` +
        `&filter_project_id=${projectId}`;

      AjaxDialog.run(`/notes/new.dialog${urlParams}`);
      this.close();
    },
    error() {
      this.$appMessage('Something went wrong. Please try again.');
    },
    loadNotesData() {
      this.loadNotes({ timeSlot: this.timeSlot }).then((response) => {
        this.notes = response.notes_data;
        this.filterProjectId = response.filter_project_id;
        this.notesId = response.notes_id;
        this.loading = false;
      }, this.error);
    },
  },
};
</script>
